/**
 * List of countries for the careers application form. Common ISO-3166 names
 * ordered alphabetically. The UK and top Skilled Worker source countries appear
 * at the top for convenience.
 */
export const COUNTRIES = [
    "United Kingdom",
    "India",
    "Nigeria",
    "Philippines",
    "Pakistan",
    "Ghana",
    "Zimbabwe",
    "Kenya",
    "South Africa",
    "Ireland",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Argentina",
    "Australia",
    "Austria",
    "Bangladesh",
    "Belgium",
    "Brazil",
    "Bulgaria",
    "Cameroon",
    "Canada",
    "China",
    "Colombia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Egypt",
    "Ethiopia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hong Kong",
    "Hungary",
    "Indonesia",
    "Iran",
    "Iraq",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Lebanon",
    "Lithuania",
    "Malaysia",
    "Malta",
    "Mexico",
    "Morocco",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Norway",
    "Poland",
    "Portugal",
    "Romania",
    "Russia",
    "Rwanda",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Somalia",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tanzania",
    "Thailand",
    "Tunisia",
    "Turkey",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United States",
    "Uzbekistan",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Other",
];

export const RIGHT_TO_WORK_OPTIONS = [
    "UK settled / pre-settled",
    "UK work visa",
    "Requires Skilled Worker sponsorship",
    "Other",
];
